var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"annotation-note",attrs:{"elevation":"0"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }